import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { updateAnnouncement } from '../../services/dashboardContentService';

const DashboardAnnouncement = ({ announcementText, onUpdate }) => {
  const { user } = useAuth();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const startEdit = () => {
    setDraft(announcementText || '');
    setEditing(true);
    setError('');
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    try {
      await updateAnnouncement(draft);
      setEditing(false);
      onUpdate();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  if (!announcementText && !user?.is_admin) {
    return null; // nothing to show, and non-admins can't add one
  }

  return (
    <div style={styles.container}>
      {editing ? (
        <>
          <textarea
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            style={styles.textarea}
            rows={3}
            placeholder="Write an announcement for all members..."
          />
          {error && <p style={styles.error}>{error}</p>}
          <div style={styles.actions}>
            <button onClick={() => setEditing(false)} style={styles.cancelBtn} disabled={saving}>Cancel</button>
            <button onClick={handleSave} style={styles.saveBtn} disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </>
      ) : (
        <div style={styles.row}>
          <p style={styles.text}>
            {announcementText || (user?.is_admin ? 'No announcement yet — click Edit to add one.' : '')}
          </p>
          {user?.is_admin && (
            <button onClick={startEdit} style={styles.editBtn}>Edit</button>
          )}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    backgroundColor: 'white',
    padding: '20px 24px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    marginBottom: '24px',
    boxSizing: 'border-box',
  },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px', flexWrap: 'wrap' },
  text: { color: '#555', fontSize: '14px', lineHeight: 1.6, margin: 0, whiteSpace: 'pre-wrap' },
  editBtn: {
    padding: '6px 14px', backgroundColor: '#fdf0e3', color: '#e67e22', border: 'none',
    borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', flexShrink: 0,
  },
  textarea: {
    width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd',
    fontSize: '14px', fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box',
  },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' },
  cancelBtn: {
    padding: '8px 16px', backgroundColor: 'transparent', border: '1px solid #ddd',
    borderRadius: '6px', cursor: 'pointer', color: '#666', fontSize: '13px',
  },
  saveBtn: {
    padding: '8px 18px', backgroundColor: '#e67e22', color: 'white', border: 'none',
    borderRadius: '6px', fontWeight: '600', cursor: 'pointer', fontSize: '13px',
  },
  error: { color: '#e74c3c', fontSize: '12px', marginTop: '6px' },
};

export default DashboardAnnouncement;
